<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>销售人员表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.manname" @keyup.enter.native="clicksearch" placeholder="请输入销售人员姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.sfcard" @keyup.enter.native="clicksearch" placeholder="请输入身份证号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.lianxifangshi" @keyup.enter.native="clicksearch" placeholder="请输入联系方式" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="primary" @click="clickexcel()">导出Excel</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel" ></TencentyunCosUploadExcel>
            注意：此处是覆盖导入
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border :cell-style="{padding: '0'}">
          <el-table-column prop="Teamname" label="团队名称" width="200"></el-table-column>
          <el-table-column prop="Id" label="销售人员编号" width="150"></el-table-column>
          <el-table-column prop="Manname" label="销售人员姓名" width="200"></el-table-column>
          <el-table-column prop="Sfcard" label="身份证号" width="200"></el-table-column>
          <el-table-column prop="Lianxifangshi" label="联系方式" width="200"></el-table-column>
          <el-table-column prop="Createtime" label="入职时间" width="200"></el-table-column>
          <el-table-column prop="Yejiyaoqiu" label="业绩要求" width="300"></el-table-column>
          <el-table-column prop="Tichengbili" label="提成比例或方案" width="300"></el-table-column>
          <el-table-column prop="Beizhu" label="备注" width="300"></el-table-column>
          <el-table-column prop="operation" label="操作" width="200" fixed="right">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickEdit(scope.row)">修改(分配团队)</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加销售人员" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item class="addAdminForm" label="销售人员姓名">
          <el-input v-model="addForm.manname"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="身份证号">
          <el-input v-model="addForm.sfcard"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="联系方式">
          <el-input v-model="addForm.lianxifangshi"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="业绩要求">
          <el-input v-model="addForm.yejiyaoqiu"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="提成比例或方案">
          <el-input v-model="addForm.tichengbili"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="备注">
          <el-input v-model="addForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <el-tab-pane label="修改" name="three" disabled="disabled">
      <Erp6SaleBaseSalespersonEdit ref="SubVuethree" v-on:triggerFunc="BackToFirst"></Erp6SaleBaseSalespersonEdit>
    </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import Erp6SaleBaseSalespersonEdit from '@/componentsSubVue/Erp6SaleBaseSalespersonEdit.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel,
    Erp6SaleBaseSalespersonEdit
  },
  name: 'MyErp6SaleBaseSalesperson',
  data () {
    return {
      activeName: 'first',
      addForm: {
        manname: '',
        sfcard: '',
        lianxifangshi: '',
        yejiyaoqiu: '',
        tichengbili: '',
        beizhu: ''
      },
      // 查询
      keywords: {
        manname: '',
        sfcard: '',
        lianxifangshi: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetErp6SaleBaseSalespersonNum()
    this.apiGetErp6SaleBaseSalespersonList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetErp6SaleBaseSalespersonList()
    },
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImportErp6SaleBaseSalesperson(url)
    },
    clickexcel () {
      this.apiExcelErp6SaleBaseSalesperson()
    },
    clickadd () {
      this.apiAddErp6SaleBaseSalesperson()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiJiGou(row.Id)
      })
    },
    clickEdit (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
    },
    clickDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelErp6SaleBaseSalesperson(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetErp6SaleBaseSalespersonNum()
      this.apiGetErp6SaleBaseSalespersonList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp6SaleBaseSalespersonList()
    },
    apiGetErp6SaleBaseSalespersonNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseSalespersonNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp6SaleBaseSalespersonList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseSalespersonList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddErp6SaleBaseSalesperson: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.addForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp6SaleBaseSalesperson, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6SaleBaseSalespersonNum()
            that.apiGetErp6SaleBaseSalespersonList()

            // 清空添加
            that.addForm.name = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelErp6SaleBaseSalesperson: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelErp6SaleBaseSalesperson, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6SaleBaseSalespersonNum()
            that.apiGetErp6SaleBaseSalespersonList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelErp6SaleBaseSalesperson: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelErp6SaleBaseSalesperson, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImportErp6SaleBaseSalesperson: function (url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportErp6SaleBaseSalesperson, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetErp6SaleBaseSalespersonList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}
.select1{
    width: 113px;
    margin-right: 15px;
}
/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
/deep/ .el-table .cell {
  white-space: pre-line;
}
</style>
